var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "subnet_tabs"
    }
  }, [_c('v-tabs', {
    attrs: {
      "vertical": "",
      "right": ""
    }
  }, [_vm._l(_vm.subnets, function (s, subnetID) {
    return _c('v-tab', {
      key: s.id
    }, [_vm._v(_vm._s(_vm._f("subnet")(subnetID)))]);
  }), _vm._l(_vm.subnets, function (s, subnetID) {
    return _c('v-tab-item', {
      key: s.id,
      attrs: {
        "vertical": true
      }
    }, [_c('Content', {
      attrs: {
        "subnet-i-d": subnetID,
        "subnet": s
      }
    })], 1);
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }